module.exports = __webpack_public_path__ + "static/media/insights.4ac5714f.png";